<template lang="pug">
div
  .md-layout
    .md-layout-item.ml-auto
      md-button.md-warning(
        style='float: right;'
        @click='createCampaign()')
        v-icon(style='color: black !important; padding-right: 4px;') mdi-plus
        span(style='color: black')
          | {{$t('commonWords.create')}}
  .md-layout
    .md-layout-item.md-size-100.mx-auto(style='padding: 0')
      DataProvider(:endpoint='endpoint', :filter='filter' ref='dataProviderCampaign' :key="componentKey")
        div(slot-scope='{ data: response, error, loading }')
          DataTable(
            v-if='response && response.data'
            :data='response && response.data'
            ref='dataTable'
            :title="$t('campaign.title')"
            :customTotal='(response && response.total) || 0'
            @pagination='handlePagination'
            :currentSort.sync='filter.orderBy',
            :currentSortOrder.sync='filter.order',
            :selectable='false'
            :loading='loading'
            customHeader
            :endpoint='endpoint'
            :labels='labels'
            :filter='filter'
            :formatLabelFunction='formatLabels'
            fileName='campaign'
            :createHeader='createHeaderPDF')
            template(slot="custom-filter")
              v-text-field(style='float: right; margin-right: 19px; width: 30%;margin-top: 20px; margin-left: 10px;'
                :placeholder="$t('table.enterWordOrDataForTheSearch')"
                hide-details
                filled
                dense
                :value='searchQuery'
                @input='updateSearch'
              )
            template(slot='footer' slot-scope='{ pagination }')
              v-row(style='justify-content: flex-end;')
                v-col(cols='auto')
                  md-field
                    label(for='pages') {{ $t('commonPhrases.perPage') }}
                    md-select(v-model='pagination.perPage' name='pages' )
                      md-option(
                        v-for='item in pagination.perPageOptions',
                        :key='item',
                        :label='item',
                        :value='item')
                        | {{ item }}
            template(slot='cells' slot-scope='{ item }')
              md-table-cell(:md-label='labels[0]' md-sort-by='ts') {{ formatLabels(item, 0) }}
              md-table-cell(:md-label='labels[1]') {{ formatLabels(item, 1) }}
              md-table-cell(:md-label='labels[2]') {{ formatLabels(item, 2) }}
              md-table-cell(:md-label='labels[3]') {{ formatLabels(item, 3) }}
              md-table-cell(:md-label='labels[4]') {{ formatLabels(item, 4) }}
              md-table-cell(:md-label='labels[5]') {{ formatLabels(item, 5) }}
              md-table-cell(:md-label='labels[6]') {{ formatLabels(item, 6) }}
              md-table-cell(:md-label='labels[7]') {{ formatLabels(item, 7) }}
              md-table-cell(:md-label="$t('campaign.actions')")
                v-row(no-gutters style='justify-content: flex-end; gap: 8px;')
                  v-col(cols='auto')
                    v-btn(
                      x-small
                      fab
                      dark
                      depressed
                      color="#20A6E5"
                      @click='editCampaign(item, true, "view")'
                    )
                      v-icon(dark )
                        | visibility
                    md-tooltip(md-direction="bottom")
                      | {{$t('campaign.viewCampaign')}}
                  v-col(cols='auto')
                    v-btn(
                      x-small
                      fab
                      depressed
                      dark
                      color="#4caf50"
                      @click='editCampaign(item, false, "edit")'
                    )
                      v-icon(dark)
                        | create
                    md-tooltip(md-direction="bottom")
                      | {{$t('commonWords.edit')}}
                  v-col(cols='auto')
                    v-btn(
                      x-small
                      fab
                      depressed
                      dark
                      color="#F19D38"
                      @click='openNotificationRecipientsList(item)'
                    )
                      v-icon(dark)
                        | mdi-account-search
                    md-tooltip(md-direction="bottom")
                      | {{$t('campaign.recipients')}}
                  v-col(cols='auto')
                    v-btn(
                      x-small
                      fab
                      dark
                      depressed
                      color="#BB2658"
                      @click='openNotificationStatus(item)'
                    )
                      v-icon(dark )
                        | mdi-playlist-check
                    md-tooltip(md-direction="bottom")
                      | {{$t('campaign.listOfTriggeredTriggers')}}
                  v-col(cols='auto')
                    v-btn(
                      @click='deleteCampaign(item)'
                      x-small
                      fab
                      dark
                      depressed
                      color="#f44336"
                    )
                      v-icon(dark )
                        | delete
                    md-tooltip(md-direction="bottom")
                      | {{$t('commonWords.delete')}}
  NotificationCampaignDialog(
    :dialog.sync='dialogManageCampaign'
    :editDisabled='editDisabled'
    @rerender='forceRerender'
    @closeDialog='closeNotificationDialog'
    :item='item'
    :id='selectedTemplate.id'
    :editStep='editStep'
    :method='method'
  )
  NotificationTriggeredList(
    :dialog.sync='dialogNotificationStatus'
    :campaignId='campaignId'
    :componentKey='componentKey'
    :selectedDate='selectedDate'
  )
  NotificationRecipientsList(
    :dialog.sync='dialogNotificationRecipientsList'
    :campaignId='campaignId'
    @rerender='forceRerender'
  )
</template>

<script>
import * as moment from 'moment'
import { mapFields } from 'vuex-map-fields'
import Swal from 'sweetalert2'
import debounce from 'lodash/debounce'
import Pagination from '@/components/Pagination.vue'
import DataTable from '@/components/DataTable.vue'
import DataProvider from '@/components/DataProvider'
import NotificationCampaignDialog from '@/components/NotificationCampaign/NotificationCampaignDialog.vue'
import NotificationTriggeredList from '@/components/NotificationCampaign/NotificationTriggeredList.vue'
import NotificationRecipientsList from '@/components/NotificationCampaign/NotificationRecipientsList.vue'
import { selectedLocale } from '@/plugins/i18n'

export default {
  components: {
    Pagination,
    DataTable,
    DataProvider,
    NotificationCampaignDialog,
    NotificationTriggeredList,
    NotificationRecipientsList
  },
  computed: {
    ...mapFields('campaign', ['selectedTemplate']),
    endpoint () {
      return `${process.env.VUE_APP_BACKEND_BASE_URL}/campaign`
    }
  },
  data () {
    return {
      componentKey: 0,
      dialogManageCampaign: false,
      dialogNotificationStatus: false,
      dialogNotificationRecipientsList: false,
      item: {},
      campaignId: '',
      editDisabled: false,
      editStep: false,
      labels: [
        'Status',
        this.$t('routes.campaign'),
        this.$t('commonWords.channel'),
        this.$t('commonWords.createdAt'),
        this.$t('commonWords.createdBy'),
        this.$t('commonWords.updatedAt'),
        this.$t('commonWords.updatedBy'),
        this.$t('campaign.recipient')],
      filter: {
        order: 'desc',
        orderBy: 'updatedAt',
        page: 0,
        perPage: 5,
        search: undefined
      },
      searchQuery: '',
      selectedDate: null,
      method: ''
    }
  },
  methods: {
    forceRerender () {
      this.$refs.dataProviderCampaign.load()
    },
    openNotificationStatus (item) {
      this.campaignId = item._id
      this.dialogNotificationStatus = true
      this.selectedDate = { from: this.filter.from, to: this.filter.to }
    },
    openNotificationRecipientsList (item) {
      this.campaignId = item._id
      this.selectedTemplate = {
        id: item._source.templateId
      }
      this.dialogNotificationRecipientsList = true
    },
    closeNotificationDialog () {
      this.dialogManageCampaign = false
      this.method = ''
      this.item = {}
    },
    deleteCampaign (item) {
      const id = item._id
      Swal.fire({
        icon: 'warning',
        title: this.$t('commonPhrases.areYouSure'),
        text: this.$t('commonPhrases.youWillNotBeAble'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: this.$t('commonWords.cancel'),
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: this.$t('commonPhrases.yesDelete'),
        buttonsStyling: false
      }).then(async (result) => {
        if (result.value) {
          try {
            await this.$axios.delete(`/campaign/${id}`)
            Swal.fire({
              title: this.$t('campaign.deleted'),
              text: `${this.$t('campaign.youDeleted')} ${item._source.name}`,
              type: 'success',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            })
            this.filter = {
              order: 'desc',
              orderBy: 'updatedAt',
              page: 0,
              perPage: 5,
              search: undefined
            }
            setTimeout(() => {
              this.forceRerender()
            }, 2000)
          } catch (error) {
            Swal.fire({
              icon: 'error',
              title: this.$t('commonWords.error'),
              html: `${error}`
            })
          }
        }
      })
    },
    createCampaign () {
      this.item = {
        _source: {}
      }
      this.method = 'create'
      this.editStep = false
      this.dialogManageCampaign = true
      this.editDisabled = false
    },
    editCampaign (item, editDisabled = false, method) {
      this.selectedTemplate = {
        id: item._source.templateId
      }
      this.editStep = true
      this.item = { ...item }
      this.dialogManageCampaign = true
      this.editDisabled = editDisabled
      this.method = method
    },
    formatLabels (item, i) {
      switch (i) {
        case 0:
          return item._source.active ? this.$t('commonWords.enabled') : this.$t('commonWords.disabled')
        case 1:
          return item._source.name
        case 2:
          return item._source.channel
        case 3:
          return this.formatDate(item, 'createdAt')
        case 4:
          return item._source.createdBy.name
        case 5:
          return this.formatDate(item, 'updatedAt')
        case 6:
          return item._source.updatedBy.name
        case 7:
          return item._source.contacts
        default:
          break
      }
    },
    formatDate (item, type) {
      let date = item._source[type]
      return moment(date).locale(selectedLocale).format('L LT')
    },
    updateSearch: debounce(function (value) {
      this.filter.search = value
      this.$refs.dataProvider.load()
    }, 400),
    createHeaderPDF (doc, total) {
      doc.setFontSize(14)
      doc.setFont(undefined, undefined, '700')
      doc.text(15, 10, this.$t('campaign.title'))

      doc.setFontSize(10)
      doc.setFont('times', undefined, '700')
      doc.text(15, 17, this.$t('chatTable.timeCourse'))
      doc.setFont('times', undefined, '300')

      let formattedDate1 = moment(this.filter.from).locale(selectedLocale).format('L LTS')
      let formattedDate2 = moment(this.filter.to).locale(selectedLocale).format('L LTS')
      doc.text(29, 17, `${formattedDate1} até ${formattedDate2}`)

      doc.setFont('times', undefined, '700')
      doc.text(15, 22, 'Total')
      doc.setFont(undefined, undefined, '300')
      doc.text(46, 22, `${total}`)

      const tableOffsetY = 30
      return tableOffsetY
    },
    handlePagination (pagination, oldPagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      if (currentPage && this.filter.page !== currentPage - 1) {
        newFilter.page = currentPage - 1
      }
      if (perPage && this.filter.perPage !== perPage) {
        newFilter.perPage = perPage
      }
      Object.assign(this.filter, newFilter)
    }
  },
  created () {
  },
  watch: {

  }
}
</script>
<style lang="scss" scoped>

  ::v-deep .md-table-head:first-child {
    width: 85px;
  }

  ::v-deep .md-table-head:last-child {
    width: 213px;
  }

  ::v-deep .md-table-head-label {
    font-size: 15px !important;
  }

</style>
